module.exports = __webpack_public_path__ + "img/recht-mang_s.f85a6035.svg";